'use client'

import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme, useIsDark } from '@/contexts/preferences-context'
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const isDark = useIsDark()

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('dark')
    } else if (theme === 'dark') {
      setTheme('system')
    } else {
      setTheme('light')
    }
  }

  return (
    <AppErrorBoundary source="theme-toggle">
      {/* Monitoring boundary ensures ErrorBoundary coverage from '@/components/common/ErrorMonitoringV2' */}
      <button
        onClick={cycleTheme}
        className="p-2 rounded-lg transition-all border border-theme-border-primary backdrop-blur-glass bg-theme-bg-secondary accent-text-primary hover:bg-theme-bg-tertiary shadow-theme-sm"
        title={`Current: ${theme} (${isDark ? 'dark' : 'light'})`}
      >
        {theme === 'light' && <Sun className="h-5 w-5" />}
        {theme === 'dark' && <Moon className="h-5 w-5" />}
        {theme === 'system' && <Monitor className="h-5 w-5" />}
      </button>
    </AppErrorBoundary>
  )
}
